import React, { useEffect, useRef, useState } from 'react'
import { FaDotCircle, FaQuestionCircle, FaTv } from 'react-icons/fa';
import { FaBaseball, FaCheck, FaCircleInfo, FaLeftRight, FaMinus, FaPlus, FaQuestion } from 'react-icons/fa6'
import { GiCricketBat } from 'react-icons/gi'
import { GoDotFill } from "react-icons/go";
import { IoMdClose } from "react-icons/io";
import RightSidebar from '../Component/Header/RightSidebar';
import { BiCricketBall } from 'react-icons/bi';
import { RiPassportFill } from 'react-icons/ri';

const Event = () => {
    const [activeTab, setActiveTab] = useState('All');

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    // -----------------blue--------------------
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    // -----------------red--------------------
    const [isDropdownOpenRed, setIsDropdownOpenRed] = useState(false);

    const toggleDropdownRed = () => {
        setIsDropdownOpenRed(!isDropdownOpenRed);
    };

    // --------------------popup-------------------
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const openPopup = () => {
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };


    // ----------------rightsidebar data---------------
    const data = [
        {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />,
            fa: "F"
        }, {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />
        }, {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />
        }, {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />
        }, {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />
        }, {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />
        }, {
            icon: <BiCricketBall />,
            Name: "Delhi Capitals",
            Name2: "Chennai Super King",
            Time: "Today 19.30",
            Tv: <FaTv />
        },
    ]

    const [showVideo, setShowVideo] = useState(false);

    const toggleVideo = () => {
        setShowVideo(!showVideo);
    };

    const [activeTabvideo, setActiveTabvideo] = useState(null);

    const toggleTab = (tabName) => {
        setActiveTabvideo((prevTab) => (prevTab === tabName ? null : tabName));
    };
    return (

        <div className='flex'>
            <div className='max-h-screen overflow-y-scroll w-[100%] lg:w-[70%]'>
                <div>
                    <div className='bg-[#169c59]  text-white flex items-center p-3.5 mx-2 md:mx-0 rounded-md leading-7'>
                        <div>
                            <p className='text-xl'>Rajasthan Royals</p>
                            <p className='text-xl'>Mumbai Indians</p>
                            <span className='flex items-center text-sm mt-1'><GiCricketBat className='mr-2' /><FaBaseball className='mr-2' /> Trent Boult</span>
                        </div>
                        <div className='ml-auto'>
                            <p>151/5 (16.1)</p>
                            <span className='border-t'>Inning1</span>
                        </div>
                    </div>
                    {/* ---------------tab------------------- */}
                    <div className="block md:hidden bg-[#22262a] text-white p-1 px-1 mx-2 rounded-lg shadow-lg   mt-2">
                        <div className="grid grid-cols-2 gap-3">
                            <button
                                className={`flex items-center w-full p-2 rounded text-center font-semibold justify-center cursor-pointer mx-auto tab-button ${activeTabvideo === 'livetv' ? ' bg-[#4c555e]  active-tab' : ''}`}
                                onClick={() => toggleTab('livetv')}
                            >
                                <FaTv className="mr-1.5" />
                                Live Tv
                            </button>
                            <button
                                className={`flex items-center w-full p-2 rounded text-center font-semibold justify-center cursor-pointer mx-auto tab-button ${activeTabvideo === 'mybets' ? ' bg-[#4c555e]  active-tab' : ''}`}
                                onClick={() => toggleTab('mybets')}
                            >
                                <RiPassportFill className='mr-1' />  My Bets <span className='bg-[#343a40] rounded text-white ml-1 px-1 '>0</span>
                            </button>
                        </div>

                        {activeTabvideo === 'livetv' && (
                            <div className="mt-2">
                                <p
                                    className="bg-[#32383e] text-sm flex items-center justify-center font-semibold text-gray-200 text-center rounded my-auto cursor-pointer"
                                    onClick={toggleTab}
                                >
                                    <iframe
                                        width="100%"
                                        height="200"
                                        src="https://www.youtube.com/embed/Q-ZOjgr9DKk?si=nXaiCGaaSSODHmzG"
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </p>
                                {/* Add the YouTube video here */}
                            </div>
                        )}
                        {activeTabvideo === 'mybets' && (
                            <div className="mt-2">
                                <p className='text-md font-semibold text-center mt-14'>My Bets is empty</p>
                                <p className='text-sm font-semibold text-center mb-14'>Click on the odds to place your bet</p>

                            </div>
                        )}
                    </div>
                    <div>
                        <div className=" dark:border-gray-700 mx-2 md:mx-0">
                            <ul className="grid grid-cols-4 gap-3 -mb-px text-sm font-medium text-center" id="default-tab" role="tablist">
                                <li
                                    className={`text-white  my-2 py-3.5 rounded-md cursor-pointer bg-[#22262a] font-semibold hover:bg-[#4c555e] ${activeTab === 'All' ? 'bg-[#4c555e]' : ''}`}
                                    role="presentation"

                                    id="All-tab"
                                    onClick={() => handleTabClick('All')}
                                    aria-controls="All"
                                    aria-selected={activeTab === 'All'}
                                >
                                    <button
                                        className=""
                                    >
                                        All
                                    </button>
                                </li>
                                <li
                                    className={`text-white  my-2 py-3.5 rounded-md cursor-pointer bg-[#22262a] font-semibold hover:bg-[#4c555e] ${activeTab === 'Match-Odd' ? 'bg-[#4c555e]' : ''}`}
                                    role="presentation"
                                    id="Match-Odd-tab"
                                    onClick={() => handleTabClick('Match-Odd')}
                                    aria-controls="Match-Odd"
                                    aria-selected={activeTab === 'Match-Odd'}
                                >
                                    <button
                                        className=""

                                    >
                                        Match-Odd
                                    </button>
                                </li>

                                <li
                                    className={`text-white  my-2 py-3.5 rounded-md cursor-pointer bg-[#22262a] font-semibold hover:bg-[#4c555e] ${activeTab === 'Bookmarker' ? 'bg-[#4c555e]' : ''}`}
                                    role="presentation"
                                    id="Bookmarker-tab"
                                    onClick={() => handleTabClick('Bookmarker')}
                                    aria-controls="Bookmarker"
                                    aria-selected={activeTab === 'Bookmarker'}
                                >
                                    <button
                                        className=""

                                    >
                                        Bookmarker
                                    </button>
                                </li>
                                <li
                                    className={`text-white  my-2 py-3.5 rounded-md cursor-pointer bg-[#22262a] font-semibold hover:bg-[#4c555e] ${activeTab === 'Fancy' ? 'bg-[#4c555e]' : ''}`}
                                    role="presentation"
                                    id="Fancy-tab"
                                    onClick={() => handleTabClick('Fancy')}
                                    aria-controls="Fancy"
                                    aria-selected={activeTab === 'Fancy'}
                                >
                                    <button className="" >
                                        Fancy
                                    </button>
                                </li>
                                {/* Add similar li elements for other tabs */}
                            </ul>
                        </div>
                        <div id="default-tab-content">
                            {/* ---------------1---------------- */}
                            <div className={` ${activeTab === 'All' ? 'block min-h-screen' : 'hidden'}`} id="All" role="tabpanel" aria-labelledby="All-tab">
                                <div className='bg-[#32383e] rounded-md my-1 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Match Odds <GoDotFill className='text-[#169c59]' /></p>

                                        <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1 border-b border-zinc-600 flex items-center relative '>
                                        <p className='text-sm font-bold'>Rajasthan Royals</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                            </div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div onClick={toggleDropdown} className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                {isDropdownOpen && (
                                                    <span className='absolute border-b-2 border-t-2 border-[#0f60a0] p-2 py-4 right-0 w-full z-10 mt-2  bg-[#1f3140]    transition-all delay-700 ease-in-out'>
                                                        <div className='flex items-center justify-end'>
                                                            <span className='relative'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                            <span className='relative ml-3'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                        </div>
                                                        <div className='my-3.5   grid grid-cols-3 md:grid-cols-7 '>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>5000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>25000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>50000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>100000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>200000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>500000</span>
                                                            <span className='bg-[#dadada] text-black p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>Clear</span>
                                                        </div>
                                                        <div className='mt-2.5 flex justify-end'>
                                                            <span className='bg-[#ef5049] p-1 mx-1 px-5 font-bold rounded-sm'>Cancel</span>
                                                            <span className='bg-[#169c59] flex items-center  p-1 mx-1 px-5 font-bold rounded-sm'><FaCheck className='mr-1' />Place Bet</span>
                                                        </div>

                                                    </span>)}
                                            </div>
                                            <div onClick={toggleDropdownRed} className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                {isDropdownOpenRed && (
                                                    <span className='absolute border-b-2 border-t-2 border-[#933d3b] p-2 py-4 right-0 w-full z-10 mt-2  bg-[#372a2d]    transition-all delay-700 ease-in-out'>
                                                        <div className='flex items-center justify-end'>
                                                            <span className='relative'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                            <span className='relative ml-3'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                        </div>
                                                        <div className='my-3.5   grid grid-cols-3 md:grid-cols-7 '>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>5000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>25000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>50000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>100000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>200000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>500000</span>
                                                            <span className='bg-[#dadada] text-black p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>Clear</span>
                                                        </div>
                                                        <div className='mt-2.5 flex justify-end'>
                                                            <span className='bg-[#ef5049] p-1 mx-1 px-5 font-bold rounded-sm'>Cancel</span>
                                                            <span className='bg-[#169c59] flex items-center  p-1 mx-1 px-5 font-bold rounded-sm'><FaCheck className='mr-1' />Place Bet</span>
                                                        </div>

                                                    </span>)}
                                            </div>

                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 flex items-center rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold'>Mumbai Indians</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>

                                </div>
                                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Bookmaker 0 Commission
                                            <GoDotFill className='text-[#169c59]' /></p>

                                        <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1 border-b border-zinc-600 flex items-center relative'>
                                        <p className='text-sm font-bold'>Rajasthan Royals</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                            </div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>

                                            </div>
                                            <div className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>

                                            </div>

                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 flex items-center rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold'>Mumbai Indians</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>

                                    </div>

                                </div>
                                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Special Maker

                                            <GoDotFill className='text-[#169c59]' /></p>

                                        <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1 border-b border-zinc-600 flex items-center relative'>
                                        <p className='text-sm font-bold'>Rajasthan Royals</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                            </div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>

                                            </div>
                                            <div className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>

                                            </div>

                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 flex items-center rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold'>Mumbai Indians</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>

                                </div>

                                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Fancy Market


                                            <GoDotFill className='text-[#169c59]' /></p>

                                    </div>

                                    {/* ----------------------------- */}
                                    <div className='bg-[#22262a] p-2 py-1  border-b border-zinc-600 grid grid-cols-1 md:grid-cols-2 gap-3 rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold flex items-center justify-center md:justify-start'>Mumbai Indians  <span className='ml-2'><FaCircleInfo onClick={openPopup} className='cursor-pointer' /></span></p>

                                        <span className='flex items-center md:ml-auto mx-auto'>

                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1    rounded-md p-1 w-36 '>
                                                <span className='text-xs'>MAX BET : 25,000</span>
                                                <span className='text-xs'>MAX MKT : 500,000</span>
                                            </span>

                                        </span>
                                    </div>
                                    {/* ----------------------------- */}
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 grid grid-cols-1 md:grid-cols-2 gap-3  rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold flex items-center justify-center md:justify-start'>FALL OF 1st WKT LSG   <span className='ml-2'><FaCircleInfo onClick={openPopup} className='cursor-pointer' /></span></p>

                                        <span className='md:ml-auto mx-auto relative'>
                                            <span className='flex items-center  blur'>

                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                <span className='flex items-center flex-col mx-1    rounded-md p-1 w-36 '>
                                                    <span className='text-xs'>MAX BET : 25,000</span>
                                                    <span className='text-xs'>MAX MKT : 500,000</span>
                                                </span>

                                            </span>
                                            <span className='absolute top-2 left-12 bg-transparent py-0.5 px-3 rounded'>BALL</span>
                                        </span>
                                    </div>

                                </div>

                                {/* -------------------------------- */}
                                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                            <GoDotFill className='text-[#169c59]' /></p>
                                        <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                    </div>

                                    {/* ----------------------------- */}
                                    <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                        <div className='flex items-center my-2 md:my-0'>

                                            <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                <span className='font-bold'>OFF SIDE</span>
                                            </span>
                                            <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>

                                            </span>
                                        </div>
                                        <div className='flex items-center my-2 md:my-0'>

                                            <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                <span className='font-bold'>LEG SIDE</span>
                                            </span>
                                            <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>

                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* -------------------------------2-------------------------------- */}
                            <div className={` ${activeTab === 'Match-Odd' ? 'block min-h-screen' : 'hidden'}`} id="Match-Odd" role="tabpanel" aria-labelledby="Match-Odd-tab">
                                <div className='bg-[#32383e] rounded-md my-1 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Match Odds <GoDotFill className='text-[#169c59]' /></p>

                                        <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1 border-b border-zinc-600 flex items-center relative '>
                                        <p className='text-sm font-bold'>Rajasthan Royals</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                            </div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div onClick={toggleDropdown} className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                {isDropdownOpen && (
                                                    <span className='absolute border-b-2 border-t-2 border-[#0f60a0] p-2 py-4 right-0 w-full z-10 mt-2  bg-[#1f3140]    transition-all delay-700 ease-in-out'>
                                                        <div className='flex items-center justify-end'>
                                                            <span className='relative'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                            <span className='relative ml-3'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                        </div>
                                                        <div className='my-3.5   grid grid-cols-3 md:grid-cols-7 '>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>5000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>25000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>50000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>100000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>200000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>500000</span>
                                                            <span className='bg-[#dadada] text-black p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>Clear</span>
                                                        </div>
                                                        <div className='mt-2.5 flex justify-end'>
                                                            <span className='bg-[#ef5049] p-1 mx-1 px-5 font-bold rounded-sm'>Cancel</span>
                                                            <span className='bg-[#169c59] flex items-center  p-1 mx-1 px-5 font-bold rounded-sm'><FaCheck className='mr-1' />Place Bet</span>
                                                        </div>

                                                    </span>)}
                                            </div>
                                            <div onClick={toggleDropdownRed} className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                {isDropdownOpenRed && (
                                                    <span className='absolute border-b-2 border-t-2 border-[#933d3b] p-2 py-4 right-0 w-full z-10 mt-2  bg-[#372a2d]    transition-all delay-700 ease-in-out'>
                                                        <div className='flex items-center justify-end'>
                                                            <span className='relative'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                            <span className='relative ml-3'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                        </div>
                                                        <div className='my-3.5   grid grid-cols-3 md:grid-cols-7 '>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>5000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>25000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>50000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>100000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>200000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>500000</span>
                                                            <span className='bg-[#dadada] text-black p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>Clear</span>
                                                        </div>
                                                        <div className='mt-2.5 flex justify-end'>
                                                            <span className='bg-[#ef5049] p-1 mx-1 px-5 font-bold rounded-sm'>Cancel</span>
                                                            <span className='bg-[#169c59] flex items-center  p-1 mx-1 px-5 font-bold rounded-sm'><FaCheck className='mr-1' />Place Bet</span>
                                                        </div>

                                                    </span>)}
                                            </div>

                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 flex items-center rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold'>Mumbai Indians</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>

                                </div>
                            </div>

                            {/* -------------------------3----------------------------- */}
                            <div className={` ${activeTab === 'Bookmarker' ? 'block min-h-screen' : 'hidden'}`} id="Bookmarker" role="tabpanel" aria-labelledby="Bookmarker-tab">
                                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Match Odds <GoDotFill className='text-[#169c59]' /></p>

                                        <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1 border-b border-zinc-600 flex items-center relative'>
                                        <p className='text-sm font-bold'>Rajasthan Royals</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                            </div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div onClick={toggleDropdown} className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                {isDropdownOpen && (
                                                    <span className='absolute border-b-2 border-t-2 border-[#0f60a0] p-2 py-4 right-0 w-full z-10 mt-2  bg-[#1f3140]    transition-all delay-700 ease-in-out'>
                                                        <div className='flex items-center justify-end'>
                                                            <span className='relative'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                            <span className='relative ml-3'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10 text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                        </div>
                                                        <div className='my-3.5   grid grid-cols-3 md:grid-cols-7 '>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>5000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>25000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>50000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>100000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>200000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>500000</span>
                                                            <span className='bg-[#dadada] text-black p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>Clear</span>
                                                        </div>
                                                        <div className='mt-2.5 flex justify-end'>
                                                            <span className='bg-[#ef5049] p-1 mx-1 px-5 font-bold rounded-sm'>Cancel</span>
                                                            <span className='bg-[#169c59] flex items-center  p-1 mx-1 px-5 font-bold rounded-sm'><FaCheck className='mr-1' />Place Bet</span>
                                                        </div>

                                                    </span>)}
                                            </div>
                                            <div onClick={toggleDropdownRed} className='cursor-pointer'>
                                                <span className='flex items-center flex-col mx-1  bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                {isDropdownOpenRed && (
                                                    <span className='absolute border-b-2 border-t-2 border-[#933d3b] p-2 py-4 right-0 w-full z-10 mt-2  bg-[#372a2d]    transition-all delay-700 ease-in-out'>
                                                        <div className='flex items-center justify-end'>
                                                            <span className='relative'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10  text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                            <span className='relative ml-3'>
                                                                <input type="text" className='bg-transparent px-0 md:px-10  text-center py-1 rounded-md' placeholder='10000' /> <FaPlus className='absolute text-xs right-1.5 top-2.5' /><FaMinus className='absolute text-xs left-1.5 top-2.5' />
                                                            </span>
                                                        </div>
                                                        <div className='my-3.5   grid grid-cols-3 md:grid-cols-7'>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>5000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>25000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>50000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>100000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>200000</span>
                                                            <span className='bg-[#4c555e] p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>500000</span>
                                                            <span className='bg-[#dadada] text-black p-1 mx-1 my-1 px-3.5 font-bold text-center rounded-sm'>Clear</span>
                                                        </div>
                                                        <div className='mt-2.5 flex justify-end'>
                                                            <span className='bg-[#ef5049] p-1 mx-1 px-5 font-bold rounded-sm'>Cancel</span>
                                                            <span className='bg-[#169c59] flex items-center  p-1 mx-1 px-5 font-bold rounded-sm'><FaCheck className='mr-1' />Place Bet</span>
                                                        </div>

                                                    </span>)}
                                            </div>

                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 flex items-center rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold'>Mumbai Indians</p>

                                        <span className='flex items-center ml-auto'>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                            <div className='hidden md:block'>
                                                <span className='flex items-center flex-col ml-1 bg-[#32383e] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span></div>
                                        </span>
                                    </div>

                                </div>

                            </div>
                            <div className={` ${activeTab === 'Fancy' ? 'block min-h-screen' : 'hidden'}`} id="Fancy" role="tabpanel" aria-labelledby="Fancy-tab">
                                <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                    <div className='flex items-center p-2'>
                                        <p className='flex items-center'>Fancy Market


                                            <GoDotFill className='text-[#169c59]' /></p>

                                    </div>

                                    {/* ----------------------------- */}
                                    <div className='bg-[#22262a] p-2 py-1  border-b border-zinc-600 grid grid-cols-1 md:grid-cols-2 gap-3 rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold flex items-center justify-center md:justify-start'>Mumbai Indians  <span className='ml-2'><FaCircleInfo onClick={openPopup} className='cursor-pointer' /></span></p>

                                        <span className='flex items-center md:ml-auto mx-auto'>

                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1    rounded-md p-1 w-36 '>
                                                <span className='text-xs'>MAX BET : 25,000</span>
                                                <span className='text-xs'>MAX MKT : 500,000</span>
                                            </span>

                                        </span>
                                    </div>
                                    <div className='bg-[#22262a] p-2 py-1  border-b border-zinc-600 grid grid-cols-1 md:grid-cols-2 gap-3 rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold flex items-center justify-center md:justify-start'>Mumbai Indians  <span className='ml-2'><FaCircleInfo onClick={openPopup} className='cursor-pointer' /></span></p>

                                        <span className='flex items-center md:ml-auto mx-auto'>

                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                <span className='font-bold'>1.23</span>
                                                <span className='text-xs'>108k</span>
                                            </span>
                                            <span className='flex items-center flex-col mx-1    rounded-md p-1 w-36 '>
                                                <span className='text-xs'>MAX BET : 25,000</span>
                                                <span className='text-xs'>MAX MKT : 500,000</span>
                                            </span>

                                        </span>
                                    </div>
                                    {/* ----------------------------- */}
                                    <div className='bg-[#22262a] p-2 py-1   border-zinc-600 grid grid-cols-1 md:grid-cols-2 gap-3  rounded-s-md rounded-e-md'>
                                        <p className='text-sm font-bold flex items-center justify-center md:justify-start'>FALL OF 1st WKT LSG   <span className='ml-2'><FaCircleInfo onClick={openPopup} className='cursor-pointer' /></span></p>

                                        <span className='md:ml-auto mx-auto relative'>
                                            <span className='flex items-center  blur'>

                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                <span className='flex items-center flex-col mx-1 bg-[#32383e] text-[#EF5480] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>
                                                    <span className='text-xs'>108k</span>
                                                </span>
                                                <span className='flex items-center flex-col mx-1    rounded-md p-1 w-36 '>
                                                    <span className='text-xs'>MAX BET : 25,000</span>
                                                    <span className='text-xs'>MAX MKT : 500,000</span>
                                                </span>

                                            </span>
                                            <span className='absolute top-2 left-12 bg-transparent py-0.5 px-3 rounded'>BALL</span>
                                        </span>
                                    </div>

                                </div>

                                {/* ----------------------------- */}
                                <div>
                                    <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                        <div className='flex items-center p-2'>
                                            <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                                <GoDotFill className='text-[#169c59]' /></p>
                                            <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                        </div>

                                        {/* ----------------------------- */}
                                        <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>OFF SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>LEG SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                        <div className='flex items-center p-2'>
                                            <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                                <GoDotFill className='text-[#169c59]' /></p>
                                            <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                        </div>

                                        {/* ----------------------------- */}
                                        <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>OFF SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>LEG SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                        <div className='flex items-center p-2'>
                                            <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                                <GoDotFill className='text-[#169c59]' /></p>
                                            <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                        </div>

                                        {/* ----------------------------- */}
                                        <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>OFF SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>LEG SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                        <div className='flex items-center p-2'>
                                            <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                                <GoDotFill className='text-[#169c59]' /></p>
                                            <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                        </div>

                                        {/* ----------------------------- */}
                                        <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>OFF SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>LEG SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                        <div className='flex items-center p-2'>
                                            <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                                <GoDotFill className='text-[#169c59]' /></p>
                                            <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                        </div>

                                        {/* ----------------------------- */}
                                        <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>OFF SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>LEG SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='bg-[#32383e] rounded-md my-2 mx-2 md:mx-0'>
                                        <div className='flex items-center p-2'>
                                            <p className='flex items-center'>DIRECTION OF 1ST BOUNDARY 2nd INNING


                                                <GoDotFill className='text-[#169c59]' /></p>
                                            <span className='ml-auto'><FaQuestionCircle onClick={openPopup} className='cursor-pointer' /></span>
                                        </div>

                                        {/* ----------------------------- */}
                                        <div className='bg-[#22262a] p-2 py-1 grid grid-cols-1 md:grid-cols-2  border-b border-zinc-600  rounded-s-md rounded-e-md'>


                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>OFF SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                            <div className='flex items-center my-2 md:my-0'>

                                                <span className='text-center mx-1    rounded-md py-2  p-0.5 '>
                                                    <span className='font-bold'>LEG SIDE</span>
                                                </span>
                                                <span className='text-center mx-1 ml-auto bg-[#32383e]  py-2 text-[#008EFB] w-16 rounded-md p-0.5 '>
                                                    <span className='font-bold'>1.23</span>

                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            {/* Add similar div elements for other tab contents */}
                        </div>
                    </div>
                </div>

                {isPopupOpen && (
                    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center">
                        <div className=" bg-black p-4 rounded-md shadow-lg max-w-screen-lg overflow-y-auto">
                            <div className='flex items-center border-b pb-2'>Rules <IoMdClose onClick={closePopup} className='ml-auto cursor-pointer' /></div>
                            {/* Popup content */}
                            <h2 className='pt-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo quae voluptas, doloremque ex excepturi esse ipsa at nemo sunt hic vel quidem ullam placeat, similique incidunt cupiditate maiores repellat aliquam deleniti aperiam! Earum, amet? Accusantium et minus suscipit consectetur rerum similique, obcaecati eum culpa? Possimus sapiente dicta nesciunt aperiam temporibus error minima voluptate mollitia optio. Animi aliquam voluptate cumque dignissimos mollitia repellat, rem repudiandae, ab sequi adipisci, perspiciatis velit error dolor nemo officia! Corrupti accusantium ipsa magni, consequatur blanditiis aspernatur magnam. Ipsum quod quos consequatur necessitatibus delectus officia dolor molestiae iure illo ipsam nulla eum at, totam iusto quasi eligendi! Sint debitis nisi veniam tempore tempora accusamus pariatur inventore, laudantium suscipit perferendis praesentium quam autem est quos aperiam et quidem dolorem, eaque repellendus! Laborum tenetur aut possimus eveniet quod repellendus, fugit eligendi veritatis, sunt quisquam sint commodi incidunt ea vitae autem voluptates totam. Cumque veritatis nihil quasi eos? Ad quaerat exercitationem soluta architecto ipsam facere voluptate delectus nostrum officia distinctio repellat sint atque optio deleniti id ipsum, numquam cumque facilis quidem at ex molestias a quod! Quaerat fugit nisi, maxime quis eos, perferendis in similique accusamus laboriosam id, optio sed quae hic aut doloremque numquam atque! Similique veritatis atque, est dolores molestias impedit minus officiis distinctio consectetur in et perferendis quia? Libero culpa nemo quisquam, eveniet placeat consequatur porro quasi aut iste, aspernatur quo magni. Minima rem amet nisi ullam numquam ipsum neque vitae asperiores. Tempora ex rerum, corporis nemo animi impedit alias deserunt magnam? Blanditiis reprehenderit repudiandae tempore atque aliquam nobis ab magni eaque explicabo nesciunt, perspiciatis laboriosam a cum iure beatae voluptatum cupiditate. Cupiditate distinctio laborum suscipit at exercitationem ea unde et aperiam. Magnam at assumenda et voluptatibus ad, molestias similique dolor rem praesentium quidem non natus molestiae in. Aliquam quam, omnis quibusdam animi accusantium ex nobis deserunt necessitatibus laborum sapiente explicabo dolor voluptas. Dolor eum perspiciatis est velit quia distinctio maiores aliquid quaerat veritatis voluptatum a consectetur quam optio cupiditate odit eos, nesciunt dignissimos labore culpa repellat? Sed officia obcaecati, cumque illum ducimus tempore ipsa rerum molestiae tempora enim odit, ut laudantium dolorum autem! Deleniti velit earum fugiat vero reiciendis neque nemo! Alias et ducimus voluptatem necessitatibus reiciendis! Minima perspiciatis vitae nihil recusandae possimus, quisquam fugit eos accusamus rem voluptatem quibusdam accusantium ducimus ut eveniet et nesciunt omnis praesentium? Harum adipisci assumenda, molestias provident ratione voluptatum id quaerat rerum quia aliquid magni, nostrum corrupti iure unde esse, excepturi animi! Officiis vitae, sunt voluptatum corrupti labore asperiores quod impedit accusantium in veritatis culpa dignissimos maxime quibusdam aliquam tenetur, ducimus recusandae! Eaque culpa minus voluptatibus placeat accusamus laudantium, molestiae voluptas voluptates obcaecati hic maxime. Veniam, unde praesentium, veritatis quis facere vel earum quisquam impedit iusto error placeat, illo laborum! Debitis iste harum eaque rerum provident, assumenda atque modi voluptatibus molestias sit obcaecati, quod ipsam? Reprehenderit, fuga suscipit fugiat accusantium accusamus numquam esse rerum quos eaque perferendis voluptate delectus aperiam iure inventore sequi nemo quisquam. Doloribus necessitatibus eveniet error, natus saepe sequi velit. Placeat id impedit laudantium odio necessitatibus fugit?</h2>

                        </div>
                    </div>
                )}
            </div>
            <div className='w-[30%] hidden lg:block ml-3'>
                <div className='bg-[#22262a] py-2 rounded-md  '>
                    <p onClick={toggleVideo} className="cursor-pointer bg-[#32383e] mx-2 py-2 text-sm flex items-center justify-center font-semibold text-gray-200 text-center px-2  rounded my-auto">
                        <FaTv className='mr-1.5' />
                        Live Tv
                    </p>
                    {showVideo && (
                        <div className="mt-2 transition-all delay-500 px-2">
                            <iframe
                                width="100%"
                                height="200"
                                src="https://www.youtube.com/embed/Q-ZOjgr9DKk?si=nXaiCGaaSSODHmzG"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    )}
                </div>
                <div className='bg-[#22262a] py-2 rounded-md  mt-2 '>
                    <p className="bg-[#32383e] mx-2 py-2 text-sm text-gray-200 text-center px-2 mb-2 font-semibold rounded my-auto">My bets <span className='bg-white text-sm rounded-full text-black px-1 '>0</span></p>
                    <p className='text-md font-semibold text-center mt-14'>My Bets is empty</p>
                    <p className='text-sm font-semibold text-center mb-14'>Click on the odds to place your bet</p>
                </div>
                <div className='bg-[#22262a] py-2 rounded-md mt-2'>
                    <p className="bg-[#32383e] mx-2 py-2 text-sm text-gray-200 text-center px-2 mb-2 rounded my-auto">Popular Events</p>

                    {data.map((val, index) => {
                        return (
                            <div className='flex mb-1 items-center mx-2 border-b-2 border-gray-700 py-2' >
                                <p className='bg-white text-black  rounded-full mr-2'>
                                    <p className='text-2xl p-1'> {val.icon}</p>
                                </p>
                                <p className='flex flex-col text-xs text-gray-200'>
                                    <span>{val.Name}</span>
                                    <span>{val.Name2}</span>
                                </p>
                                <p className='ml-auto'>
                                    <span className='flex justify-center text-xs text-gray-200'>{val.Time}</span>
                                    <span className='flex justify-end mt-1'>
                                        <span className='mr-2 text-green-600'>  {val.Tv}</span>
                                        {val.fa ? (<span className='ml-2 bg-white text-black p-0 px-2 m-0 text-xs' >{val.fa}</span>) : ("")}

                                    </span>
                                </p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Event